/*
 * @Author: bianbinbin
 * @Date: 2023-12-12 15:29:34
 * @LastEditors: bianbinbin
 * @LastEditTime: 2025-04-15 09:39:58
 * @PageTitle: 页面...
 * @Description: 描述...
 * @FilePath: /ejx-web/src/router/module/aircraft-info.js
 */
const aircraftInfo = r => require.ensure([], () => r(require('@/views/aircraftInfo/aircraftInfo.vue'), 'aircraftInfo'))
const todayOperation = r =>
  require.ensure([], () => r(require('@/views/aircraftInfo/todayOperation.vue'), 'todayOperation'))
const normalRate = r =>
  require.ensure([], () => r(require('@/views/aircraftInfo/normalRate.vue'), 'normalRate'))
const router = [
  {
    path: '/aircraftInfo',
    name: 'aircraftInfo',
    meta: {
      title: '机队规模-飞机信息'
    },
    component: aircraftInfo
  },
  {
    path: '/todayOperation',
    name: 'todayOperation',
    meta: {
      title: '今日运行'
    },
    component: todayOperation
  },
  {
    path: '/normalRate',
    name: 'normalRate',
    meta: {
      title: 'HO执飞机场正常率'
    },
    component: normalRate
  }
]

export default router
